<template>
  <div id="lav-approval-status">
    <v-card class="premium-dialog-card overflow-hidden">
      <!-- Premium Header -->
      <v-app-bar class="premium-app-bar px-4" dark flat height="100">
        <div class="d-flex flex-column">
          <div class="d-flex align-center">
            <v-icon large class="mr-3">mdi-check-decagram-outline</v-icon>
            <span class="text-h5 font-weight-black letter-spacing-1 uppercase">{{ pageDescription }}</span>
          </div>
          <div class="text-caption white--text opacity-80 ml-12">NHQ Administration Panel</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePrompt" class="white--text">
          <v-icon size="32">mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="pa-10">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" class="mb-8">
              <v-card flat class="target-info-card pa-6">
                <div class="d-flex align-center">
                  <v-icon x-large color="indigo lighten-2" class="mr-6">mdi-office-building-marker</v-icon>
                  <div>
                    <div class="text-overline indigo--text font-weight-bold" style="line-height: 1">Acknowledgement For
                    </div>
                    <div class="text-h4 font-weight-black grey--text text--darken-3">{{ rowData.LomName }}</div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- History Section -->
            <v-col cols="12" v-if="Lav && Lav.length > 0">
              <div class="history-section mb-10">
                <div class="d-flex align-center mb-4">
                  <v-icon color="green darken-2" class="mr-3">mdi-history-text</v-icon>
                  <span
                    class="text-subtitle-1 font-weight-black green--text text--darken-3 uppercase letter-spacing-1">Acknowledgement
                    History Archive</span>
                </div>
                <v-card flat class="history-box pa-8 rounded-xl border-green" v-html="Lav">
                </v-card>
              </div>
            </v-col>

            <v-form ref="form2" v-model="valid1" lazy-validation style="width: 100%" v-if="!viewOnly">
              <!-- Input Section -->
              <v-col cols="12">
                <div class="input-section pa-8 rounded-xl elevation-2 bg-white">
                  <div class="d-flex align-center mb-6">
                    <v-icon color="amber darken-3" class="mr-3">mdi-note-edit</v-icon>
                    <span class="text-h6 font-weight-black grey--text text--darken-3">Process Remarks</span>
                  </div>

                  <v-textarea outlined v-model="Reason" :rules="ReasonRules" name="input-7-4"
                    label="Enter final acknowledgement remarks here..." class="premium-textarea mb-8" counter rows="4"
                    rounded backgroundColor="grey lighten-5"></v-textarea>

                  <v-divider class="mb-8"></v-divider>

                  <v-row class="px-2">
                    <v-col cols="12" sm="4">
                      <v-btn :disabled="!valid1" @click.prevent="submitForm(1)" :loading="ApproveLoadingFlag"
                        class="premium-action-btn btn-yes w-100" x-large block>
                        <v-icon left>mdi-check-decagram</v-icon> Approve
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-btn :disabled="!valid1" @click.prevent="submitForm(2)" :loading="RejectLoadingFlag"
                        class="premium-action-btn btn-no w-100" x-large block>
                        <v-icon left>mdi-close-circle</v-icon> Reject
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-btn @click.prevent="closePrompt()" class="premium-action-btn btn-cancel w-100" x-large block>
                        <v-icon left>mdi-close</v-icon> Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-form>
            <v-col cols="12" class="d-flex justify-center mt-4" v-if="viewOnly">
              <v-btn color="primary" large rounded shaped @click="closePrompt">
                <v-icon left>mdi-close</v-icon> Close
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    showLavDialog: {
      type: Boolean,
      required: true,
    },
    rowData: {
      required: true,
    },
    category: {
      required: true,
    },
    zoneCode: {
      required: true,
    },
    regionCode: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TrainingDocuments: [],
      ResultFlag: false,
      StartupLoadingFlag: false,
      records: {},
      Lav: [],

      ReportType: "",

      Reason: "",
      ReasonRules: [(v) => !!v || "Remarks is required"],

      valid1: true,
      StatusFlag: false,
      ApproveLoadingFlag: false,
      RejectLoadingFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;
        console.log({ LomId });

        this.pageData();
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    rowData: function () {
      console.log("watch recordData");
      this.StartupLoadingFlag = false;
      var tr = this.rowData;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      this.ResultFlag = n1 > 0 ? true : false;
      this.ReportType = n1 > 0 ? tr.CategoryName : "";
      this.TrainingDocuments = n1 > 0 ? tr.TrainingDocuments : [];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideLavDialog", this.StatusFlag);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getRecordDetails();
    },
    getRecordDetails() {
      console.log("getRecordDetails is called");

      var tr = this.rowData || {};
      var LoTrainingId = tr.LomTrainingLavId || tr.LomTrainingId || tr.LomLavId || "";
      console.log("LoTrainingId=" + LoTrainingId);

      var LomId = tr.LomId || tr.LomCode || 0;
      console.log("LomId=" + LomId);

      if (LoTrainingId !== "" && LoTrainingId !== null && LoTrainingId !== undefined) {
        var upload = {
          UserInterface: 1,
          Category: 2,
          LoTraining: LoTrainingId,
          Lo: LomId,
        };
        console.log({ upload });

        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/show";
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;
            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log("records=" + records);

            if (flag == 1) {
              thisIns.Lav = records.LavDescription;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (!LoTrainingId) {
          message += "LO training code should not be empty.";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var tr = this.rowData || {};
      console.log({ tr });

      var id = tr.LomTrainingLavId || tr.LomTrainingId || tr.LomLavId || 0;
      console.log(id);

      var category = tr.LavCategoryId || tr.TrainingCategoryId || 2;
      console.log({ category });

      // var validate1 = false;

      if (validate1 && Status > 0 && id > 0) {
        switch (Status) {
          case 1:
            this.ApproveLoadingFlag = true;
            break;

          case 2:
            this.RejectLoadingFlag = true;
            break;

          default:
            break;
        }

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-training/approval-update";
        var upload = {
          UserInterface: Status,
          LomTraining: id,
          Reason: this.Reason,
          Category: category,
          ZoneCode: this.zoneCode, // ✅ FIXED
          RegionCode: this.regionCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        this.StatusFlag = false;

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            switch (Status) {
              case 1:
                thisIns.ApproveLoadingFlag = false;
                break;

              case 2:
                thisIns.RejectLoadingFlag = false;
                break;

              default:
                break;
            }

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        if (!validate1) {
          message = "Kindly fill the required fields. ";
        }
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style scoped>
.premium-dialog-card {
  /* Approved Design System */
  --navy: #3A67B1;
  --aqua: #0097D7;
  --gold: #EDBE38;
  --seaform: #56BDA3;
  --text-90: #414042;
  --text-off-black: #0A0F29;
  --white: #FFFFFF;

  border-radius: 32px !important;
  background: #f8f9fa !important;
  font-size: 1.1rem !important;
}

.premium-app-bar {
  background: linear-gradient(135deg, var(--navy) 0%, var(--aqua) 100%) !important;
}

.target-info-card {
  background: white !important;
  border-radius: 24px !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;
  color: var(--text-off-black) !important;
}

.history-box {
  background: white !important;
  line-height: 1.6;
  font-size: 1.1rem !important;
  color: var(--text-90) !important;
}

.border-green {
  border-left: 6px solid var(--seaform) !important;
  background: #f1f8e9 !important;
}

.input-section {
  border: 1px solid #eceff1;
}

.premium-textarea>>>fieldset {
  border-color: #cfd8dc !important;
}

.premium-textarea.v-input--is-focused>>>fieldset {
  border-color: var(--navy) !important;
  border-width: 2px !important;
}

.premium-action-btn {
  text-transform: none !important;
  font-weight: 800 !important;
  letter-spacing: 0.8px !important;
  border-radius: 16px !important;
  color: white !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-size: 1.1rem !important;
}

.btn-yes {
  background: linear-gradient(135deg, var(--seaform) 0%, #2e7d32 100%) !important;
  box-shadow: 0 6px 20px rgba(46, 125, 50, 0.3) !important;
}

.btn-yes:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(46, 125, 50, 0.4) !important;
}

.btn-no {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  box-shadow: 0 6px 20px rgba(230, 81, 0, 0.3) !important;
}

.btn-no:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(230, 81, 0, 0.4) !important;
}

.btn-cancel {
  background: linear-gradient(135deg, #757575 0%, #424242 100%) !important;
  box-shadow: 0 6px 20px rgba(66, 66, 66, 0.3) !important;
}

.btn-cancel:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(66, 66, 66, 0.4) !important;
}

.text-h4 {
  font-size: 2.125rem !important;
  line-height: 2.5rem !important;
  font-weight: 900 !important;
}

.text-h5 {
  font-size: 1.8rem !important;
  font-weight: 800 !important;
}

.text-h6 {
  font-size: 1.4rem !important;
  font-weight: 800 !important;
}

.uppercase {
  text-transform: uppercase !important;
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}
</style>
